import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Label } from 'components/HeroSemantic';

class ThemeLinkButton extends Component {
  static propTypes = {
    aStyles: PropTypes.object.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    label: PropTypes.string.isRequired,
    size: PropTypes.string,
    style: PropTypes.object,
  };

  static defaultProps = {
    size: 'large',
  };

  render() {
    const { aStyles, className, onClick, size, style, label, disabled } = this.props;
    return (
      <Label
        as="a"
        basic
        className={className}
        size={size}
        onClick={!disabled ? onClick : null}
        style={{
          border: 'none',
          display: 'block',
          cursor: disabled ? 'not-allowed' : 'pointer',
          margin: 0,
          paddingLeft: 0,
          paddingRight: 0,
          ...aStyles,
          ...style,
          color: disabled ? 'var(--owner-text-muted)' : (style && style.color) || aStyles.color,
        }}
      >
        {label}
      </Label>
    );
  }
}

export default connect(state => ({ aStyles: state.tenant.theme.a }))(ThemeLinkButton);
